import React from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";

const WalletHistory = ({meta}) => {
  const columns = [
    { field: "id", header: "Id" },
    { field: "date", header: "Date" },
    { field: "user_type", header: "User Type" },
    { field: "detail", header: "Detail" },
    { field: "currency", header: "Currency" },
    { field: "wallet_amount", header: "Wallet Amount" },
    { field: "add_cut", header: "Add/Cut" },
    { field: "wallet", header: "Wallet" },
    { field: "comment", header: "Comment" },
  ];

  //
  const data = [
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
    {
      id: "2144",
      date: "06 Jun 2024",
      user_type: "User",
      detail: "Just In",
      currency: "USD",
      wallet_amount: "12671.25",
      add_cut: "2.00",
      wallet: "12673.25",
      comment: "Paypal Payment",
    },
  ];
  const searchBy = {
    filterType: "Search By",
    inputName: "search_by",
    options: [
      {
        name: "User",
        code: "User",
      },
      {
        name: "Order no",
        code: "Order no",
      },
      {
        name: "Store",
        code: "Store",
      },
    ],
  };

  const filters = [
    {
      filterType: "delivery Type",
      inputName: "delivery_type",
      options: [
        {
          name: "Delivery",
          code: "Delivery",
        },
        {
          name: "Pickup",
          code: "Pickup",
        },
        {
          name: "Schedule",
          code: "Schedule",
        },
        {
          name: "Now",
          code: "Now",
        },
      ],
    },
    {
      filterType: "Select Payment Type",
      inputName: "select_payment_type",
      options: [
        {
          name: "Cash",
          code: "Cash",
        },
        {
          name: "Paystack",
          code: "Paystack",
        },
        {
          name: "Razorpay",
          code: "Razorpay",
        },
        {
          name: "Paytabs",
          code: "Paytabs",
        },
        {
          name: "Stripe",
          code: "Stripe",
        },
        {
          name: "Paypal",
          code: "Paypal",
        },
      ],
    },
  ];

  return (
    <div className='main-content'>
      <CommonLayout />
      <BasicTable
        data={data}
        columns={columns}
        SearchBy={searchBy}
        // filters={filters}
        WeekRange={false}
        MonthRange={true}
      />
    </div>
  );
};

export default WalletHistory;
